import { ResultActions } from './ResultActions';
import { ResultBase } from './ResultBase';
import { ResultButton } from './ResultButton';
import { ResultDefaultStatusIcon } from './ResultDefaultStatusIcon';
import { ResultIcon } from './ResultIcon';
import { ResultIllustration } from './ResultIllustration';
import { ResultSubTitle } from './ResultSubTitle';
import { ResultTitle } from './ResultTitle';

// Compose the compound component API
export const ResultComposable = Object.assign(ResultBase, {
  Icon: ResultIcon,
  Illustration: ResultIllustration,
  Title: ResultTitle,
  SubTitle: ResultSubTitle,
  Actions: ResultActions,
  Button: ResultButton,
  DefaultStatusIcon: ResultDefaultStatusIcon
});
